import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {
  findIndex as _findIndex,
  forEach as _forEach,
} from 'lodash';

import {getDescriptionInCurrentLanguage, getNameInCurrentLanguage} from 'helpers/intl';
import { S3_LINKS_DIV } from 'js/constants';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class CategorySelection extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    const {
      appIntl,
      openCategory,
      category,
      user,
      login
    } = this.props;
    let catImg = category.default_img ? category.default_img.variations[_findIndex(category.default_img.variations, {'variation_type': 'thumb'})].file.web_link : S3_LINKS_DIV.ITEM_IMGS_THUMB_DEFAULT;
    let catIndex = -1;
    _forEach(user.ancestors, (ancestor) => {
      if(ancestor !== 'CreacheckAdmin') {
        catIndex = _findIndex(category.assets.imgs, function (o) {
          return o.owner.id === ancestor
        });
        if (catIndex >= 0) {
          catImg = category.assets.imgs[catIndex].variations[_findIndex(category.assets.imgs[catIndex].variations, {'variation_type': 'thumb'})].file.web_link;
        }
      }
    });
    
    return (
      <div id={category.id} className="category" onClick={() => {openCategory(category.id)}}>
        <div className="category-thumb">
          <img
            src={catImg}
          />
        </div>
        <div className="category-name" style={{ position: 'relative' }}>
          {getDescriptionInCurrentLanguage(category?.description, appIntl) && (
            <span style={{ position: 'absolute', top: '5px', left: '5px' }}>
              <OverlayTrigger placement="top" overlay={<Tooltip>{getDescriptionInCurrentLanguage(category?.description, appIntl)}</Tooltip>}>
                <i className="far fa-info-circle" />
              </OverlayTrigger>
            </span>
          )}
          <h5>{getNameInCurrentLanguage(category.name, appIntl)}</h5>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    login: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {

  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CategorySelection)
  )
);
